<template>
  <div id="subscribers">
    <b-card overlay :img-src="gif" class="text-center" img-height="350px">
      <span class="card-header text-center">
        <strong>Subscribers</strong>
      </span>
      <div
        v-if="count < target"
        @mouseover="
          sendEvent('subscribers', 'hover', 'subscribers-gauge-interaction')
        "
      >
        <br />
        <gauge
          title="Subscribers"
          :current="count"
          :target="target"
          :colour="gaugeColour"
        ></gauge>
      </div>
      <div v-else>
        <span style="display:none"> {{ (gif = stars) }} </span>
        <b-card-img :src="image"></b-card-img>
        <b-list-group flush>
          <b-list-group-item>Achievement Complete!</b-list-group-item>
          <b-list-group-item>
            <strong>Target:</strong>
            {{ target.toLocaleString() }}
          </b-list-group-item>
          <b-list-group-item>
            <strong>Current:</strong>
            {{ count.toLocaleString() }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <br />

      <b-list-group flush>
        <b-list-group-item>
          <div :style="style">
            <b-container class="text-center">
              <b-button
                @click="
                  subscribeToUser();
                  sendEvent('subscribers', 'click', 'subscribe-user-btn');
                "
                >Subscribe to {{ channelName }}</b-button
              >
            </b-container>
          </div>
        </b-list-group-item>

        <b-list-group-item>
          <div :style="style">
            <b-container v-if="this.state == 'released'" class="text-center">
              <b-button
                @mouseover="displayBalance()"
                @click="
                  purchase('SubscriberMessage-100');
                  sendEvent('subscribers', 'click', 'subscribers-100-btn');
                "
                >Boast subscription to {{ channelName }}</b-button
              >
            </b-container>

            <b-container v-else class="text-center">
              <b-button
                @mouseover="displayBalance()"
                @click="
                  purchase('SubscriberMessage-1');
                  sendEvent('subscribers', 'click', 'subscribers-1-btn');
                "
                >Boast subscription to {{ channelName }}</b-button
              >
            </b-container>
          </div>
        </b-list-group-item>

        <b-list-group-item>
          <b-container class="text-center">
            <div v-if="this.users.length == 0">
              <strong>Featured Subscribers</strong>
            </div>
            <div v-else>
              <strong>Featured Subscriber:</strong>

              <b-list-group style="max-width: 300px;">
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar
                    class="mr-2"
                    :src="displayedSub.profile"
                    badge
                    badge-top
                    variant="warning"
                    size="3.5em"
                  >
                    <template #badge>
                      <div
                        v-if="
                          displayedSub !== null &&
                            displayedSub.tier.includes('3')
                        "
                      >
                        <b-icon
                          animation="throb"
                          variant="warning"
                          icon="star-fill"
                        ></b-icon>
                      </div>
                      <div
                        v-if="
                          displayedSub !== null &&
                            displayedSub.tier.includes('2')
                        "
                      >
                        <b-icon
                          animation="throb"
                          variant="danger"
                          icon="star-fill"
                        ></b-icon>
                      </div>
                      <div v-else>
                        <b-icon
                          animation="throb"
                          variant="success"
                          icon="star-fill"
                        ></b-icon>
                      </div>
                    </template>
                  </b-avatar>
                  <span class="mr-auto"
                    ><strong>{{ displayedSub.username }}</strong></span
                  >
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-container>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import Gauge from "@/components/utils/Gauge.vue";
import ConfigAPI from "@/api/config.js";
import hearts from "@/assets/hearts.gif";
import stars from "@/assets/stars.gif";
import trophy from "@/assets/trophy.gif";
import SubscribersAPI from "@/api/subscribers.js";
import { clearTimeout, setTimeout, setInterval } from "timers";
import BitsAPI from "@/api/bits.js";
import UserAPI from "@/api/user.js";

export default {
  name: "subscribers",
  data() {
    return {
      users: [],
      gaugeColour: "#5583c7",
      count: 1,
      target: 10,
      image: trophy,
      channelName: "",
      ButtonTxtColour: "#FFFFFF",
      ButtonBkgColour: "#5583c7",

      subIndex: 0,
      displayedSub: {
        tier: "",
        profile: "",
        plan: "",
      },

      image: trophy,
      channelName: "",

      // images
      gif: "",
      gifOne: stars,
      gifTwo: hearts,
      trophy: trophy,

      resetTimeout: undefined,
      gifTimeout: undefined,
      state: "",
    };
  },
  mounted() {
    this.setConfig();
    this.getSubscribers();

    this.channelName = ConfigAPI.getUsername();

    this.eventBus.$on("new-subscriber", this.newSubscriber);
    this.eventBus.$on("subscribers-update", this.subscribersUpdate);
    this.eventBus.$on("subscriber-boast", this.subBoast);

    setInterval(this.displaySub.bind(this), 15000);
    this.state = this.$store.getters.getReleasedState();
  },
  activated: function() {
    ga("set", "page", "/subscribers");
    ga("send", "pageview");
  },
  methods: {
    setConfig: function() {
      var globalConfig = ConfigAPI.getGlobalConfig();

      if (globalConfig.images) {
        var images = globalConfig.images;
        if (images.one) {
          this.gifOne = images.one;
        }
        if (images.two) {
          this.gifTwo = images.two;
        }
      }

      var config = ConfigAPI.getBroadcasterConfig();
      if (config.subscribers) {
        var subscribers = config.subscribers;
        if (subscribers.gauge_colour) {
          this.gaugeColour = subscribers.gauge_colour;
        }
        if (subscribers.message) {
          this.message = subscribers.message;
        }
        if (subscribers.target) {
          this.target = subscribers.target;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.font_colour) {
          this.ButtonTxtColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.ButtonBkgColour = panel.background_colour;
        }
      }
      return;
    },
    getSubscribers: function() {
      SubscribersAPI.getSubscribers()
        .then((resp) => {
          if (resp.data.count) {
            this.count = resp.data.count;
          }

          if (resp.data.subscribers) {
            this.users = resp.data.subscribers;
            this.displaySub();
          }
        })
        .catch((error) => {});
    },
    newSubscriber: function(subscriber) {
      this.count += 1;
      this.users.push({
        username: subscriber.user_name,
        tier: subscriber.tier,
        plan: subscriber.plan_name,
      });

      clearTimeout(this.gifTimeout);
      clearTimeout(this.resetTimeout);

      this.gif = this.gifOne;
      this.gifTimeout = setTimeout(
        function() {
          this.gif = this.gifTwo;
        }.bind(this),
        60000
      );

      this.resetTimeout = setTimeout(
        function() {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    subBoast: function() {
      clearTimeout(this.gifTimeout);
      clearTimeout(this.resetTimeout);

      this.gif = this.gifOne;
      this.gifTimeout = setTimeout(
        function() {
          this.gif = this.gifTwo;
        }.bind(this),
        60000
      );

      this.resetTimeout = setTimeout(
        function() {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    subscribersUpdate: function(subscribers) {
      this.count = subscribers.count;
      this.users = subscribers.subscribers;
    },
    displaySub: function() {
      if (this.users.length == 0) {
        return;
      }
      if (this.subIndex == this.users.length) {
        this.subIndex = 0;
      }
      this.displayedSub = this.users[this.subIndex];
      this.subIndex++;
    },
    subscribeToUser: function() {
      window.open("https://subs.twitch.tv/" + this.channelName, "_blank");
    },
    isNotLinked: function() {
      const { channelId } = this.$store.state;
      if (!Twitch.ext.viewer.id) {
        return true;
      }
      return false;
    },
    purchase: function(sku) {
      BitsAPI.purchase(sku);
    },
    displayBalance: function() {
      BitsAPI.showBalance();
    },
  },
  computed: {
    style() {
      return {
        "--btnBkgColour": this.ButtonBkgColour,
        "--btnFontColour": this.ButtonTxtColour,
      };
    },
  },
  components: {
    Gauge,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.card {
  border-color: var(--btnBkgColour);
  border-style: none;
}

.card #followersCard {
  border-style: groove;
}

.card-header {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.b-avatar {
  background: none;
}

.b-avatar .b-avatar-badge {
  background: none;
}
</style>

<style>
.popover {
  max-width: none;
}

.b-avatar {
  background: none;
}

.b-avatar .b-avatar-badge {
  background: none;
}
</style>
